import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

export function ChannelCard({ image, title, url }) {
  return (
    <div className="max-w-sm rounded-lg group overflow-hidden shadow-lg">
      <div className="relative h-60 bg-cover bg-center ">
        <div className="absolute top-0 bottom-0 inset-0">
          <img
            src={image}
            alt={title}
            className="group-hover:scale-110 transition-all duration-300"
          />
        </div>
        {/* Overlay */}
        <Link to={url}>
          {" "}
          <div className="absolute inset-0 bg-black/40"></div>
        </Link>
        {/* Text Content */}{" "}
        <div className="absolute bottom-0 p-4">
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <Link
            to={url}
            className="bg-white group-hover:bg-red-600 group-hover:text-white duration-300 transition-all flex items-center justify-center gap-2 rounded px-3 py-1 text-red-600 text-sm mt-1"
          >
            <FaArrowRight /> Explore
          </Link>
        </div>
      </div>
    </div>
  );
}
